// SummaryTable.js
import React, { useState } from "react";
import "./summaryTable.css"; // スタイルを適用するCSSファイルを追加

// const SummaryTable = ({ emptyCount, filledCount }) => {
  const SummaryTable = ({ summaryData }) => { 
    if (!summaryData || typeof summaryData !== "object") {
      return null;
    }
  
  const summaryArray = Object.values(summaryData);


  return (
    <div className="summary-container">
        <table className="summary-table">
            <thead>
              <tr>
                <th>タイプ</th>
                <th>合計数量</th>
                <th>合計容量[L/min]</th>
              </tr>
            </thead>
            <tbody>              
                {summaryArray.map((item) => (
                <tr key={item.type}>
                  <td>{item.type}</td>
                  <td>{item.count}</td>
                  <td>{item.totalCapacity}</td>
                </tr>
              ))}
            </tbody>
        </table>
    </div>
  );
};

export default SummaryTable;